import { useQuery } from '@tanstack/react-query';
import { supabase } from '../../api';

const getOrders = async (userId: string) => {
  // Early return if userId is invalid
  if (!userId || userId === 'undefined') {
    return [];
  }

  const { data: orders, error: orderError } = await supabase
    .from('orders')
    .select('id')
    .eq('created_by', userId)
    .eq('status', 'Pending');

  if (orderError) {
    throw new Error(`Error fetching orders: ${orderError.message}`);
  }

  if (!orders || orders.length === 0) {
    return [];
  }

  const orderIds = orders.map((order) => order.id);

  const { data: orderItems, error: orderItemsError } = await supabase
    .from('order_items')
    .select('*, product(*), service(*, service_pricing_duration(*))')
    .in('order_id', orderIds);

  if (orderItemsError) {
    throw new Error(`Error fetching order items: ${orderItemsError.message}`);
  }

  return orderItems;
};

export default function useGetOrders(userId: string) {
  return useQuery({
    queryKey: ['useGetOrders', userId],
    queryFn: () => getOrders(userId),
    staleTime: 30000, // 30 seconds - reduced refetches, invalidation handles updates
    enabled: !!userId && userId !== 'undefined',
  });
}
